import { render } from "./TestResultProductForEdu.vue?vue&type=template&id=55154715&scoped=true"
import script from "./TestResultProductForEdu.vue?vue&type=script&lang=js"
export * from "./TestResultProductForEdu.vue?vue&type=script&lang=js"

import "./TestResultProductForEdu.vue?vue&type=style&index=0&id=55154715&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55154715"]])

export default __exports__